module.exports = __webpack_public_path__ + "static/cuenca-68f5e6f557fe3488c8e8351cb3f33be5.jpg";